export default __webpack_public_path__ + "static/media/foto9.3b53c050.jpg";